export default function LocationMap() {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-slate-50">
      <div className="container mx-auto px-4">
        {/* 재기목형 위치 */}
        <div className="max-w-6xl mx-auto mb-20">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="bg-gradient-to-r from-slate-800 to-slate-700 px-8 py-6">
              <h2 className="text-3xl font-bold text-white mb-2">재기목형 본사</h2>
              <p className="text-slate-300">목형 제작 전문</p>
            </div>
            
            <div className="grid md:grid-cols-2 gap-0">
              {/* 지도 */}
              <div className="h-96 md:h-auto">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3162.8!2d126.991!3d37.566!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzfCsDMzJzU3LjYiTiAxMjbCsDU5JzI3LjYiRQ!5e0!3m2!1sko!2skr!4v1234567890"
                  width="100%"
                  height="100%"
                  style={{ border: 0, minHeight: '400px' }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="재기목형 위치"
                ></iframe>
              </div>
              
              {/* 정보 */}
              <div className="p-8 bg-slate-50">
                <div className="space-y-6">
                  <div>
                    <div className="flex items-start mb-3">
                      <i className="ri-map-pin-line text-2xl text-amber-600 mr-3 mt-1"></i>
                      <div>
                        <h3 className="font-bold text-slate-800 mb-1 text-lg">주소</h3>
                        <p className="text-slate-600 leading-relaxed">
                          서울특별시 중구 을지로 27가길 22<br />
                          대륙빌딩 (주교동)
                        </p>
                      </div>
                    </div>
                  </div>
                  
                  <div>
                    <div className="flex items-start mb-3">
                      <i className="ri-phone-line text-2xl text-amber-600 mr-3 mt-1"></i>
                      <div>
                        <h3 className="font-bold text-slate-800 mb-1 text-lg">연락처</h3>
                        <p className="text-slate-600">
                          <strong className="text-slate-800">대표전화:</strong> 02-2263-8248<br />
                          <strong className="text-slate-800">팩스:</strong> 02-2263-3616
                        </p>
                      </div>
                    </div>
                  </div>
                  
                  <div>
                    <div className="flex items-start mb-3">
                      <i className="ri-mail-line text-2xl text-amber-600 mr-3 mt-1"></i>
                      <div>
                        <h3 className="font-bold text-slate-800 mb-1 text-lg">이메일</h3>
                        <p className="text-slate-600">jk8248@hanmail.net</p>
                      </div>
                    </div>
                  </div>
                  
                  <div>
                    <div className="flex items-start mb-3">
                      <i className="ri-customer-service-line text-2xl text-amber-600 mr-3 mt-1"></i>
                      <div>
                        <h3 className="font-bold text-slate-800 mb-1 text-lg">내선번호</h3>
                        <p className="text-slate-600">
                          관리: 1번<br />
                          도안팀: 0번, 2번, 3번, 4번
                        </p>
                      </div>
                    </div>
                  </div>
                  
                  <div className="pt-4 border-t border-slate-200">
                    <div className="flex items-start">
                      <i className="ri-subway-line text-2xl text-amber-600 mr-3 mt-1"></i>
                      <div>
                        <h3 className="font-bold text-slate-800 mb-2 text-lg">대중교통</h3>
                        <div className="space-y-2 text-sm text-slate-600">
                          <p><strong className="text-slate-800">지하철:</strong> 2호선 을지로3가역 8번 출구 도보 5분</p>
                          <p><strong className="text-slate-800">버스:</strong> 을지로3가 정류장 하차</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* 뉴테크 위치 */}
        <div className="max-w-6xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="bg-gradient-to-r from-amber-600 to-amber-500 px-8 py-6">
              <h2 className="text-3xl font-bold text-white mb-2">뉴테크</h2>
              <p className="text-amber-50">레이저 가공 전문</p>
            </div>
            
            <div className="grid md:grid-cols-2 gap-0">
              {/* 지도 */}
              <div className="h-96 md:h-auto">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3162.8!2d126.991!3d37.566!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzfCsDMzJzU3LjYiTiAxMjbCsDU5JzI3LjYiRQ!5e0!3m2!1sko!2skr!4v1234567891"
                  width="100%"
                  height="100%"
                  style={{ border: 0, minHeight: '400px' }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="뉴테크 위치"
                ></iframe>
              </div>
              
              {/* 정보 */}
              <div className="p-8 bg-amber-50">
                <div className="space-y-6">
                  <div>
                    <div className="flex items-start mb-3">
                      <i className="ri-map-pin-line text-2xl text-slate-700 mr-3 mt-1"></i>
                      <div>
                        <h3 className="font-bold text-slate-800 mb-1 text-lg">주소</h3>
                        <p className="text-slate-600 leading-relaxed">
                          서울특별시 중구 을지로27가길 3<br />
                          중앙프라자 1층 4호
                        </p>
                      </div>
                    </div>
                  </div>
                  
                  <div>
                    <div className="flex items-start mb-3">
                      <i className="ri-phone-line text-2xl text-slate-700 mr-3 mt-1"></i>
                      <div>
                        <h3 className="font-bold text-slate-800 mb-1 text-lg">연락처</h3>
                        <p className="text-slate-600">
                          <strong className="text-slate-800">고객센터:</strong> 02-2261-2017
                        </p>
                      </div>
                    </div>
                  </div>
                  
                  <div>
                    <div className="flex items-start mb-3">
                      <i className="ri-mail-line text-2xl text-slate-700 mr-3 mt-1"></i>
                      <div>
                        <h3 className="font-bold text-slate-800 mb-1 text-lg">이메일</h3>
                        <p className="text-slate-600">nt2017@daum.net</p>
                      </div>
                    </div>
                  </div>
                  
                  <div className="pt-4 border-t border-amber-200">
                    <div className="flex items-start">
                      <i className="ri-subway-line text-2xl text-slate-700 mr-3 mt-1"></i>
                      <div>
                        <h3 className="font-bold text-slate-800 mb-2 text-lg">대중교통</h3>
                        <div className="space-y-2 text-sm text-slate-600">
                          <p><strong className="text-slate-800">지하철:</strong> 2호선 을지로3가역 8번 출구 도보 3분</p>
                          <p><strong className="text-slate-800">버스:</strong> 을지로3가 정류장 하차</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="bg-white rounded-lg p-4 border border-amber-200">
                    <div className="flex items-start">
                      <i className="ri-information-line text-xl text-amber-600 mr-2 mt-0.5"></i>
                      <p className="text-sm text-slate-600 leading-relaxed">
                        재기목형 본사와 가까운 거리에 위치해 있습니다.<br />
                        방문 시 두 곳 모두 둘러보실 수 있습니다.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* 방문 안내 */}
        <div className="max-w-4xl mx-auto mt-16">
          <div className="bg-gradient-to-r from-slate-800 to-slate-700 rounded-2xl p-8 md:p-12 text-center text-white shadow-xl">
            <i className="ri-time-line text-5xl mb-4 text-amber-400"></i>
            <h3 className="text-2xl md:text-3xl font-bold mb-4">운영 시간</h3>
            <div className="space-y-2 text-lg">
              <p><strong>평일:</strong> 오전 9:00 - 오후 6:00</p>
              <p><strong>토요일:</strong> 오전 9:00 - 오후 1:00</p>
              <p className="text-slate-300 text-base mt-4">일요일 및 공휴일 휴무</p>
            </div>
            <div className="mt-8 pt-8 border-t border-slate-600">
              <p className="text-amber-300 font-semibold mb-3">방문 전 연락 주시면 더욱 자세한 안내를 받으실 수 있습니다.</p>
              <a 
                href="tel:02-2263-8248" 
                className="inline-flex items-center justify-center bg-amber-500 hover:bg-amber-600 text-white font-bold px-8 py-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
              >
                <i className="ri-phone-line text-xl mr-2"></i>
                02-2263-8248
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
